const eventBus = {
    on: (event: any, callback: any): void => {
        document.addEventListener(event, data => callback(data.detail));
    },
    dispatch: (event: any, data: any): void => {
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove: (event: any, callback: any): void => {
        document.removeEventListener(event, callback);
    }
};

export default eventBus;
